import { Sync } from "@mui/icons-material";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { useWooCommerceBackfillStatus } from "features/dataConnectors/hooks/useWooCommerceBackfillStatus";

function WooCommerceBackfillBanner() {
  const status = useWooCommerceBackfillStatus();

  if (!status) {
    return null;
  }

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: 0,
        px: 2,
      }}
    >
      <Alert
        severity="info"
        icon={<Sync fontSize="small" />}
        sx={{
          py: 0.25,
          alignItems: "center",
          width: "100%",
          maxWidth: 720,
          "& .MuiAlert-message": {
            overflow: "hidden",
            width: "100%",
          },
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}
        >
          <Typography variant="body2" noWrap sx={{ flex: 1, minWidth: 0 }}>
            {status.message}
          </Typography>
          <CircularProgress size={14} color="inherit" />
        </Box>
      </Alert>
    </Box>
  );
}

export default WooCommerceBackfillBanner;
